import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-play-solid.tsx
/**
* icon.24.play.solid
*
* Keywords: triangle, right, forward, next, navigation, pointer, chevron, directional
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTcgNy43NTJjMC0xLjM0NyAxLjQ1OS0yLjE4OSAyLjYyNS0xLjUxNWw3LjU4NiA0LjM4MWExLjYgMS42IDAgMCAxIDAgMi43NzJsLTcuNTg2IDQuMzgyQzguNDU4IDE4LjQ0NiA3IDE3LjYwMyA3IDE2LjI1NnoiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=15311-40438
*/
const Icon24PlaySolid = memo(function Icon24PlaySolid(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M7 7.752c0-1.347 1.459-2.189 2.625-1.515l7.586 4.381a1.6 1.6 0 0 1 0 2.772l-7.586 4.382C8.458 18.446 7 17.603 7 16.256z"
		})
	});
});
//#endregion
export { Icon24PlaySolid };

//# sourceMappingURL=icon-24-play-solid.js.map